var Environments;
(function (Environments) {
    Environments["production"] = "https://video-services.statsbomb.com/tracking";
    Environments["staging"] = "https://video-services.staging.statsbomb.com/tracking";
})(Environments || (Environments = {}));

export { Environments };
//# sourceMappingURL=environment.js.map
